<template>
  <div :class="'menu ' + $store.getters['menuState'] + ' menu--' + $store.getters['auth/role']">
    <div
      class="menu__account account"
      v-if="
        $store.getters['auth/isRole']('ROLE_ADMIN') != true &&
        $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') != true
      "
    >
      <div class="account__picto">
        <div class="picto-container">
          <img class="picto" src="/static/img/pictos/compte.svg" />
        </div>
      </div>
      <div class="account__info my-account">
        <span class="my-account__name"> {{ user.firstname }} {{ user.lastname }} </span>
        <a class="close-menu" @click="closeMenu()">
          <img src="/static/img/pictos/fermer-bleu.svg" alt="" />
        </a>
        <router-link :to="{ name: 'Profile' }" class="my-account__btn" @click.native="closeMenu()">
          <span>Mon compte</span>
          <img src="/static/img/pictos/flecheblanche.svg" alt="" />
        </router-link>
        <router-link class="my-account__link" :to="{ name: 'Logout' }" @click.native="closeMenu()">
          Déconnexion
        </router-link>
      </div>
    </div>
    <div class="menu__links">
      <ul class="links" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
        <li class="link">
          <router-link :to="{ name: 'OrderList' }" @click.native="closeMenu()">
            <img src="/static/img/pictos/commande.svg" alt="" class="link__picto" />
            <span class="link__text">Mes commandes</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'HomeTechs' }" @click.native="closeMenu()">
            <img src="/static/img/pictos/technicien.svg" alt="" class="link__picto" />
            <span class="link__text">Mes techniciens</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'ProductFavoritesList' }" @click.native="closeMenu()">
            <img
              src="/static/img/pictos/produitfavorisfondvert.svg"
              alt=""
              class="link__picto"
            />
            <span class="link__text">Mes produits favoris</span>
          </router-link>
        </li>
      </ul>
      <ul class="links" v-else-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
        <li class="link">
          <router-link :to="{ name: 'Stock' }" @click.native="closeMenu()">
            <img src="/static/img/pictos/stockcamion.svg" alt="" class="link__picto" />
            <span class="link__text">Mon stock</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'ReapproList' }" @click.native="closeMenu()">
            <img src="/static/img/pictos/reappro.svg" alt="" class="link__picto" />
            <span class="link__text">Mes réappros</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'ReapproParam' }" @click.native="closeMenu()">
            <img src="/static/img/pictos/reappro-parametres.svg" alt="" class="link__picto" />
            <span class="link__text">Paramètres du réappro</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'OrderList' }" @click.native="closeMenu()">
            <img src="/static/img/pictos/commande.svg" alt="" class="link__picto" />
            <span class="link__text">Mes commandes</span>
          </router-link>
        </li>
        <li class="link" v-for="item in items">
          <router-link
            :to="{ name: 'ProductListCat', params: { cat: item.id, catname: item.name } }"
            :item="item"
            :itemName="item.name"
            :key="item.id"
            @click.native="closeMenu()"
          >
            <img src="/static/img/pictos/commande.svg" alt="" class="link__picto" />
            <span class="link__text link__text--product-family">{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
      <ul
        class="links"
        v-else-if="
          $store.getters['auth/isRole']('ROLE_ADMIN') == true ||
          $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') == true
        "
      >
        <li class="link">
          <router-link :to="{ name: 'AdminOrderList' }">
            <span class="link__text">Commandes</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'AdminUserList' }">
            <span class="link__text">Utilisateurs</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'AdminProductList' }">
            <span class="link__text">Produits</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'AdminVehicleList' }">
            <span class="link__text">Véhicules</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'AdminAgencyList' }">
            <span class="link__text">Agences</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'AdminProductFamilyList' }">
            <span class="link__text">Familles de produits</span>
          </router-link>
        </li>
        <li class="link">
          <router-link :to="{ name: 'AdminGroupList' }">
            <span class="link__text">Groupes</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { languages_trad } from "@/traductions/config";
import { defaultLocale } from "@/traductions/config";
export default {
  name: "Menu",
  data() {
    return {
      locale: this.$i18n.locale,
      languages: languages_trad,
    };
  },
  created() {},
  computed: {
    // Récupération de mes infos personnelles
    user: function () {
      let user = this.$store.getters["auth/user"];

      // Cas ou le retour était en LocalStorage et sous la forme d'un json "stringifié" : on le retransforme en objet JS.
      if (typeof user == "string") {
        return JSON.parse(user);
      } else {
        return user;
      }
    },
    items: function () {
      let items = this.$store.getters["productfamily/getAll"];

      if (items) {
        return items;
      }
    },
  },
  methods: {
    // Méthode qui ferme le menu (utilise la méthode Toggle mais comme le composant actuel est le menu, il était forcément ouvert avant donc le toggle le ferme dans 100% des cas)
    closeMenu() {
      this.$store.dispatch("toggleMenu");
    },
  },
  watch: {
    locale(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("defaultLocale", lang);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.menu {
  position: fixed;
  width: 355px;
  background-color: $color1;
  height: calc(100vh - 135px);
  z-index: 2;
  top: 135px;
  left: -355px;
  transition: left 300ms ease-out;
  &.active {
    left: 0;
  }
  .close-menu {
    position: absolute;
    right: 20px;
    top: 20px;
    img {
      width: 10px;
    }
  }
  &--ROLE_SUPER_ADMIN,
  &--ROLE_ADMIN {
    position: relative;
  }
  &--ROLE_TECHNICIAN {
    top: 75px;
    height: calc(100vh - 75px);
    width: 100%;
    left: -100%;
    z-index: 100;
    .menu__links {
      overflow: auto;
      height: calc(100vh - (75px + 190px));
    }
  }
  &__account {
    background-color: white;
    width: 100%;
    padding: 35px 80px 35px 35px;
  }
  .account {
    display: flex;
    width: 100%;
    &__picto {
      width: 40%;
      .picto-container {
        width: 35px;
        height: 35px;
        background-color: $color2;
        border-radius: 50%;
      }
    }
    &__info {
      width: 60%;
    }
  }
  .my-account {
    display: flex;
    width: 100%;
    flex-direction: column;
    &__name {
      font-size: 15px;
      font-family: "ClanPro";
    }
    &__btn {
      background-color: $color2;
      padding: 14px 18px;
      margin-top: 20px;
      font-family: "ClanProBold";
      display: flex;
      flex-direction: row;
      height: auto;
      justify-content: space-between;
      align-items: flex-start;
      span {
        height: auto;
        font-size: 12px;
        color: white;
        align-self: center;
      }
      img {
        width: 16px;
      }
      &:hover {
        text-decoration: none;
      }
    }
    &__link {
      font-size: 10px;
      font-family: "ClanPro";
      color: $color1;
      text-decoration: underline;
      margin-top: 20px;
      &:hover {
      }
    }
  }
  .links {
    padding: 0;
    list-style: none;
    .link {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      &__picto {
        width: 30px;
        margin-right: 18px;
      }
      &__text {
        color: white;
        font-family: "ClanProBold";
        font-size: 14px;
        &--product-family {
          font-family: "ClanPro";
          font-size: 12px;
        }
      }
    }
    a {
      &:hover {
        text-decoration: none;
      }
    }
  }
  &__links {
    padding: 50px 35px;
  }
  &--ROLE_SUPER_ADMIN,
  &--ROLE_ADMIN {
    position: relative;
    width: 100%;
    height: auto;
    background: white;
    left: 0;
    top: 0;
    .menu__links {
      width: 100%;
      padding: 20px 0;
      margin: 0;
      .links {
        display: flex;
        width: 100%;
        margin-bottom: 0;
      }
      .link {
        width: calc(100% / 6) !important;
        text-align: center;
        display: inline-block;
        color: $mystockblue;
        font-family: "ClanPro";
        font-size: 12px;
        border-left: 1px solid $color2;
        line-height: 40px;
        margin-bottom: 0;
        a {
          span {
            color: $mystockblue;
            font-family: "ClanPro";
            font-size: 12px;
          }
          &:first-of-type {
            border-left: none;
          }
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 400px) and (max-width: 800px) {
  .menu {
    &__account {
      padding: 55px 80px 35px 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/Menu.vue